import { useState } from "react";
import { Asset } from "types";
import AssetDetailsPopup from "components/pop-up/AssetDetailsPopup";

const AssetDetailCard = ({ asset }: { asset?: Asset }) => {
  const [showDetail, setShowDetail] = useState(false);

  // Format the asset information for the card display
  const assetInfo = asset
    ? {
        uniqueId: asset.asset_unique_id || "N/A",
        category: asset.asset_category || "N/A",
        number: asset.asset_number || "N/A",
        value: asset.estimation_of_money
          ? `$${asset.estimation_of_money}`
          : "N/A",
        condition: asset.asset_condition || "N/A",
        owner: asset.owner || "N/A",
        location:
          [
            asset.asset_location_region,
            asset.asset_location_zone,
            asset.asset_location_town,
          ]
            .filter(Boolean)
            .join(", ") || "Not specified",
      }
    : null;

  return (
    <>
      <div className="flex items-center p-3 bg-white border rounded-lg w-[400px] m-2">
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-900">
            {assetInfo?.category} - {assetInfo?.uniqueId}
          </h3>
          <p className="text-xs text-gray-600">
            <span className="font-semibold">Value:</span> {assetInfo?.value}
            <span className="font-semibold ml-3">Condition:</span>{" "}
            {assetInfo?.condition}
          </p>
          <p className="text-xs text-gray-600">
            <span className="font-semibold">Location: </span>{" "}
            {assetInfo?.location}
          </p>
        </div>
        <button
          onClick={() => setShowDetail(!showDetail)}
          className="ml-4 text-gray-500 hover:text-gray-700 focus:outline-none p-2 bg-gray-500 rounded-full border-[#d4d4d4] border"
          style={{ background: "#f5f5f5", color: "#6b72806b" }}
        >
          <span className="sr-only">View Asset Details</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            aria-hidden="false"
            role="img"
            aria-label="View"
          >
            <path
              d="M12 5.5C7 5.5 3.1 9.2 1.5 12c1.6 2.8 5.5 6.5 10.5 6.5s8.9-3.7 10.5-6.5C20.9 9.2 17 5.5 12 5.5z"
              fill="currentColor"
            />
            <circle cx="12" cy="12" r="3" fill="#fff" />
            <circle cx="12" cy="12" r="1.2" fill="currentColor" />
          </svg>
        </button>
      </div>

      {asset && (
        <AssetDetailsPopup
          setShowDetail={setShowDetail}
          showDetail={showDetail}
          asset={asset}
          title="Asset Details"
          description="Complete information about the asset"
        />
      )}
    </>
  );
};

export default AssetDetailCard;
